import React from "react";
import PropTypes from "prop-types";
import BaseLayout from "core/layouts/Base";

function TwoColumn({
  className,
  style,
  leftSectionStyle,
  rightSectionStyle,
  leftSection,
  rightSection,
  isLeftFillSpace,
  isRightFillSpace,
  ...props
}) {
  return (
    <BaseLayout
      className={`${className}`}
      style={style}
      {...props}
    >
      {({ Row, Column }) => (
        <>
          <Column
            isFillSpace={isLeftFillSpace}
            style={leftSectionStyle}
          >
            {leftSection}
          </Column>
          <Column
            isFillSpace={isRightFillSpace}
            style={rightSectionStyle}
          >
            {rightSection}
          </Column>
        </>
      )}
    </BaseLayout>
  );
}

TwoColumn.defaultProps = {
  className: "",
  style: {},
  leftSectionStyle: {},
  rightSectionStyle: {},
  isLeftFillSpace: false,
  isRightFillSpace: false,
};

TwoColumn.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  leftSectionStyle: PropTypes.object,
  rightSectionStyle: PropTypes.object,
  leftSection: PropTypes.node.isRequired,
  rightSection: PropTypes.node.isRequired,
  isLeftFillSpace: PropTypes.bool,
  isRightFillSpace: PropTypes.bool,
};

export default TwoColumn;
